import React from "react";
import { useSiteData } from "../../context/SiteDataContext";
import { CheckCircle2, Radio, Clock } from "lucide-react";

const statusConfig = {
  done: { icon: CheckCircle2, color: "text-green-400", bg: "bg-green-400/20", border: "border-green-400/40", label: "DONE", labelBg: "bg-green-400/10 text-green-400 border-green-400/30" },
  live: { icon: Radio, color: "text-yellow-400", bg: "bg-yellow-400/20", border: "border-yellow-400/40", label: "LIVE", labelBg: "bg-yellow-400/10 text-yellow-400 border-yellow-400/30" },
  upcoming: { icon: Clock, color: "text-gray-500", bg: "bg-gray-500/20", border: "border-gray-500/40", label: "UPCOMING", labelBg: "bg-gray-500/10 text-gray-500 border-gray-500/30" },
};

const RoadmapSection = () => {
  const { content } = useSiteData();
  const roadmap = content?.roadmap || [];

  return (
    <section id="roadmap" className="relative py-20 overflow-hidden">
      <div className="absolute inset-0 bg-[#060d06]" />
      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl sm:text-4xl font-extrabold text-center mb-16">
          <span className="text-yellow-400">ROAD</span>{" "}
          <span className="text-white">MAP</span>
        </h2>
        <div className="relative">
          <div className="absolute left-6 sm:left-8 top-0 bottom-0 w-0.5 bg-gradient-to-b from-green-400 via-yellow-400 to-gray-600" />
          <div className="flex flex-col gap-10">
            {roadmap.map((phase, idx) => {
              const config = statusConfig[phase.status] || statusConfig.upcoming;
              const StatusIcon = config.icon;
              return (
                <div key={idx} className="relative flex gap-6 sm:gap-8">
                  <div className={`relative z-10 w-12 h-12 sm:w-16 sm:h-16 rounded-full ${config.bg} ${config.border} border-2 flex items-center justify-center flex-shrink-0`}>
                    <StatusIcon size={20} className={config.color} />
                  </div>
                  <div className="flex-1 pb-2">
                    <div className="flex flex-wrap items-center gap-3 mb-3">
                      <h3 className="text-white font-bold text-xl">{phase.phase}</h3>
                      <span className={`text-xs font-bold uppercase tracking-wider px-3 py-1 rounded-full border ${config.labelBg}`}>{config.label}</span>
                    </div>
                    <div className="bg-[#0d1a0d] border border-[#1a3a1a] rounded-xl p-5">
                      <ul className="space-y-2">
                        {(phase.items || []).map((item, i) => (
                          <li key={i} className="flex items-start gap-2 text-gray-400 text-sm">
                            <span className={`mt-1 ${config.color}`}>
                              {phase.status === "done" ? <CheckCircle2 size={14} /> : <div className="w-1.5 h-1.5 rounded-full bg-current mt-1" />}
                            </span>
                            <span className={phase.status === "done" ? "line-through opacity-60" : ""}>{item}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default RoadmapSection;
